import { useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import { toast } from 'sonner';
import { Button, Card, CardContent, Input, Label } from '@werkstatt/ui';
import api from '../../lib/api';
import { readApiError } from '../../lib/apiError';

const EMPTY = { current_password: '', new_password: '', confirm_password: '' };

export function SecurityTab() {
  const [form, setForm] = useState(EMPTY);
  const [error, setError] = useState('');

  const changeMutation = useMutation({
    mutationFn: async () =>
      (await api.post('/auth/change-password', {
        current_password: form.current_password,
        new_password: form.new_password,
      })).data,
    onSuccess: () => {
      toast.success('Passwort geändert');
      setForm(EMPTY);
    },
    onError: (err: unknown) => toast.error(readApiError(err, 'Ändern fehlgeschlagen')),
  });

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    setError('');
    if (form.new_password.length < 8) {
      setError('Das neue Passwort muss mindestens 8 Zeichen lang sein.');
      return;
    }
    if (form.new_password !== form.confirm_password) {
      setError('Die neuen Passwörter stimmen nicht überein.');
      return;
    }
    changeMutation.mutate();
  };

  return (
    <Card variant="glass">
      <CardContent className="p-6">
        <form onSubmit={handleSubmit} className="space-y-4 max-w-md">
          <div className="space-y-2">
            <Label htmlFor="current-password">Aktuelles Passwort</Label>
            <Input
              id="current-password"
              type="password"
              value={form.current_password}
              onChange={(e) => setForm({ ...form, current_password: e.target.value })}
              autoComplete="current-password"
              required
            />
          </div>

          <div className="space-y-2">
            <Label htmlFor="new-password">Neues Passwort</Label>
            <Input
              id="new-password"
              type="password"
              value={form.new_password}
              onChange={(e) => setForm({ ...form, new_password: e.target.value })}
              autoComplete="new-password"
              minLength={8}
              required
            />
          </div>

          <div className="space-y-2">
            <Label htmlFor="confirm-new-password">Neues Passwort bestätigen</Label>
            <Input
              id="confirm-new-password"
              type="password"
              value={form.confirm_password}
              onChange={(e) => setForm({ ...form, confirm_password: e.target.value })}
              autoComplete="new-password"
              minLength={8}
              required
            />
          </div>

          {error && <p className="text-sm text-destructive">{error}</p>}

          <Button type="submit" disabled={changeMutation.isPending}>
            {changeMutation.isPending ? 'Wird geändert…' : 'Passwort ändern'}
          </Button>
        </form>
      </CardContent>
    </Card>
  );
}
